import { useSanctumConfig } from "./composables/useSanctumConfig.js";
import { interceptors } from "./interceptors/index.js";
import { determineCredentialsMode } from "./utils/credentials.js";
function useClientInterceptors() {
  const [request, response, responseError] = [
    [...interceptors.request],
    [...interceptors.response],
    [...interceptors.responseError]
  ];
  return [request, response, responseError];
}
export function createHttpClient(nuxtApp, logger) {
  const options = useSanctumConfig();
  const [
    requestInterceptors,
    responseInterceptors,
    responseErrorInterceptors
  ] = useClientInterceptors();
  const httpOptions = {
    baseURL: options.baseUrl,
    credentials: determineCredentialsMode(),
    redirect: "manual",
    retry: options.client.retry === true ? 1 : options.client.retry,
    // false or number
    async onRequest(context) {
      for (const interceptor of requestInterceptors) {
        await nuxtApp.runWithContext(async () => {
          await interceptor(nuxtApp, context, logger);
        });
      }
      await nuxtApp.callHook("sanctum:request", nuxtApp, context, logger);
    },
    async onResponse(context) {
      for (const interceptor of responseInterceptors) {
        await nuxtApp.runWithContext(async () => {
          await interceptor(nuxtApp, context, logger);
        });
      }
      await nuxtApp.callHook("sanctum:response", nuxtApp, context, logger);
    },
    async onRequestError(context) {
      await nuxtApp.callHook("sanctum:error:request", context);
    },
    async onResponseError(context) {
      for (const interceptor of responseErrorInterceptors) {
        await nuxtApp.runWithContext(async () => {
          await interceptor(nuxtApp, context, logger);
        });
      }
      await nuxtApp.callHook("sanctum:error:response", context);
    }
  };
  return $fetch.create(httpOptions);
}
